import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { systemConfigurationsRoutes } from '../system-configs.routes';
import { Page } from "../../../page/page";

@Component({
  selector: 'app-configs-outlet',
  imports: [Page],
  templateUrl: './configs-outlet.html',
  styleUrl: './configs-outlet.scss',
})
export class ConfigsOutlet {
  menuItems = systemConfigurationsRoutes;

  constructor(private readonly route: ActivatedRoute) {}

  parentRoute: any;

  ngOnInit(): void {
    if (this.route.routeConfig) {
      const { children, ...otherRouteAttributes } = this.route.routeConfig;
      this.parentRoute = otherRouteAttributes;
    }
  }
}
